var _rect, _rect2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 313,
    viewBox: "0 0 326 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 34,
    width: 326,
    height: 279,
    rx: 20,
    fill: "#0032C8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_393_5465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 34,
    width: 326,
    height: 279
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 34,
    width: 326,
    height: 279,
    rx: 20,
    fill: "#0032C8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_393_5465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 147,
    width: 69,
    height: 173,
    fill: "#0166FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.025,
    cy: 169.5,
    r: 26.5253,
    fill: "#7EC8F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5253,
    cy: 162.5,
    r: 26.5253,
    fill: "#7EC8F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239,
    y: 199,
    width: 67,
    height: 121,
    fill: "#02139D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.819 204.187L239.313 178.682H315.574L340.313 204.187H264.819Z",
    fill: "#DCF2FD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.313,
    cy: 232.242,
    r: 20.9141,
    fill: "#55C88F"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_393_5465",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.526 51.2734C333.526 68.5894 319.489 82.6267 302.173 82.6267C284.857 82.6267 270.82 68.5894 270.82 51.2734"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M333.526 51.2734C333.526 68.5894 319.489 82.6267 302.173 82.6267C284.857 82.6267 270.82 68.5894 270.82 51.2734",
    fill: "#1E56FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.677 51.2734C331.677 67.5679 318.468 80.7772 302.173 80.7772V84.4762C320.511 84.4762 335.376 69.6108 335.376 51.2734H331.677ZM302.173 80.7772C285.879 80.7772 272.669 67.5679 272.669 51.2734H268.97C268.97 69.6108 283.836 84.4762 302.173 84.4762V80.7772Z",
    fill: "#1E56FF",
    mask: "url(#path-9-inside-1_393_5465)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.173 21.8418C285.918 21.8418 272.741 35.0191 272.741 51.2742C272.741 67.5292 285.918 80.7066 302.173 80.7066C318.428 80.7066 331.605 67.5292 331.605 51.2742C331.605 35.0191 318.428 21.8418 302.173 21.8418ZM268.899 51.2742C268.899 32.8974 283.796 18 302.173 18C320.55 18 335.447 32.8974 335.447 51.2742C335.447 69.651 320.55 84.5484 302.173 84.5484C283.796 84.5484 268.899 69.651 268.899 51.2742Z",
    fill: "#1E56FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.863 147.019C288.547 147.019 274.51 132.982 274.51 115.666C274.51 98.3498 288.547 84.3125 305.863 84.3125",
    fill: "#02139D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 46,
    height: 141,
    fill: "#02139D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_393_5465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.515 5.16882C152.515 4.32443 152.515 3.47684 152.519 2.63245L151.36 0.240567C151.072 -0.0901235 150.461 -0.0772812 150.192 0.263041L149.213 2.62603V5.16239C148.291 5.16239 146.794 5.87836 146.794 6.7709C146.794 7.66023 147.536 8.38582 148.451 8.38582H149.203L149.043 99.2069C149.034 104.058 146.471 108.087 142.8 107.994C139.955 107.92 137.478 105.49 137.069 101.528C136.979 100.652 136.234 99.9742 135.322 99.9742H135.254C134.205 99.9742 133.379 100.86 133.507 101.875C134.224 107.509 138.672 111.548 142.899 111.555C146.205 111.561 148.919 110.03 150.503 107.262C152.464 103.837 152.346 100.064 152.352 96.3013C152.359 92.7375 152.365 84.3226 152.371 80.7556C152.381 75.7792 152.391 70.7996 152.4 65.8232C152.41 60.1469 152.423 54.4706 152.432 48.7975C152.442 43.1372 152.455 37.4801 152.464 31.8199L152.493 17.0384C152.499 14.1585 152.503 11.2753 152.509 8.39545H153.024C153.943 8.39545 154.688 7.67628 154.688 6.78695C154.688 5.89762 153.434 5.17203 152.515 5.17203V5.16882Z",
    fill: "#55C88F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.815 66.2731L122.477 62.2277C124.771 48.2167 130.167 34.8992 138.259 23.2544L148.49 8.53711C123.648 9.54523 102.32 24.2818 91.859 45.4043C88.6653 51.8479 86.4893 58.8887 85.5293 66.3148C90.9086 64.7127 97.1358 63.7977 103.795 63.8106C110.31 63.8234 116.454 64.7191 121.815 66.2763V66.2731Z",
    fill: "#02139D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.191 58.236L176.922 66.9239H177.575C183.262 65.0489 189.998 63.9669 197.249 63.9798C204.475 63.9926 211.249 65.0938 216.996 66.9785C215.867 57.4944 212.747 48.6203 208.065 40.7929C196.51 21.4652 175.441 8.5137 151.338 8.46875C150.628 8.46875 149.92 8.48159 149.216 8.50086L157.344 20.4731C167.313 32.821 171.879 45.3231 175.188 58.2296L175.191 58.236Z",
    fill: "#02139D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.477 62.2273L121.814 66.2727C121.872 66.2887 121.933 66.308 121.99 66.324C128.874 63.2676 138.304 61.5274 148.714 61.5467C159.677 61.5659 169.565 63.5372 176.535 66.9244H176.925L175.194 58.2366C171.885 45.33 167.322 32.828 157.351 20.4801L149.223 8.50781C148.98 8.51423 148.736 8.52387 148.493 8.5335L138.263 23.2508C130.167 34.8988 124.774 48.2131 122.48 62.2241L122.477 62.2273Z",
    fill: "#0166FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.814 66.2715L121.792 66.4095C121.856 66.3806 121.923 66.3518 121.99 66.3229C121.933 66.3068 121.872 66.2875 121.814 66.2715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3092 118.42L88.6692 124.189L78.7715 172.602L85.8852 185.017L94.5477 182.844L101.988 157.531L93.3092 118.42Z",
    fill: "#D67086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.102 304.092L112.208 310.279L112.95 313.001L127.258 310.279L127.997 304.339L120.102 304.092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.27 300.371L187.348 306.731L185.595 311.425L170.977 306.731L170.113 301.045L178.27 300.371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.701 199.076L112.208 247.771L118.64 304.091L127.997 304.383L132.676 231.638L136.769 194.09L108.701 199.076Z",
    fill: "#0166FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.11 190.861L140.563 232.554L169.664 301.155L179.569 300.262L166.621 224.81L154.797 182.992L125.11 190.861Z",
    fill: "#0166FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.624 106.316C116.752 106.32 116.88 106.326 117.008 106.332C123.12 106.631 130.522 114.68 134.81 119.432C145.879 131.696 153.607 145.752 159.392 161.465C162.509 169.924 165.258 178.526 167.837 187.172C168.551 189.56 173.553 211.412 174.765 211.566C162.324 209.97 149.799 208.724 137.408 209.588C125.018 210.452 112.694 213.499 102.07 220.055C96.6302 192.013 92.6077 162.977 91.2925 134.563C91.1357 131.163 90.6173 127.657 90.9373 124.28C91.3053 120.388 93.2157 118.635 95.3854 115.682C96.1278 114.67 96.8766 113.653 97.7854 112.815C102.576 108.406 110.221 106.101 116.627 106.31L116.624 106.316Z",
    fill: "#D67086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.771 205.33C119.763 202.736 144.058 196.449 159.05 193.855C151.204 167.721 138.717 138.688 124.157 115.729C121.517 111.565 118.218 107.221 113.491 106.232C108.429 105.172 99.552 108.521 98.5664 114.204C97.1264 122.516 100.115 133.981 101.037 142.386C103.123 161.406 101.149 186.541 104.771 205.33Z",
    fill: "#FFFFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.906 88.5422C102.992 78.217 89.8914 84.9239 89.0402 95.2491C88.4801 102.052 95.0722 109.539 101.885 110.069C102.023 111.703 102.231 113.334 102.509 114.952C104.231 114.481 105.952 114.009 107.677 113.537C108.212 113.392 108.82 113.174 108.992 112.647C109.098 112.329 109.005 111.983 108.912 111.658C108.602 110.57 108.288 109.482 107.978 108.396C108.093 108.316 108.208 108.233 108.324 108.146C111.159 105.976 112.448 102.194 112.285 98.6202C112.122 95.0469 110.682 91.6468 108.906 88.5422Z",
    fill: "#EACDB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.525 92.036C111.382 94.7843 111.645 99.186 111.833 102.968C112 106.32 112.499 108.323 116.045 107.379C118.045 106.846 121.609 105.941 122.454 103.742C123.094 102.079 120.745 99.2245 119.501 98.2549C118.55 97.5165 117.126 97.6353 116.195 96.8711C115.811 96.5565 115.552 96.1167 115.312 95.68C114.342 93.8949 113.648 91.9622 113.251 89.9716C112.982 88.6199 112.848 87.2201 112.313 85.9487C111.539 84.1059 109.219 82.706 107.715 81.4314C104.918 79.0588 98.566 77.248 96.2652 81.486C95.7404 82.4524 95.75 83.6082 95.8236 84.7062C95.8684 85.3612 95.9356 86.0322 96.2332 86.6165C97.4204 88.9442 99.7308 88.2218 101.766 88.5557C104.272 88.9667 106.697 90.2766 108.521 92.0328L108.525 92.036Z",
    fill: "#292949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0639 101.426C92.7935 103.134 94.6047 104.505 94.4287 106.355C94.3519 107.18 93.8719 107.899 93.5487 108.66C92.6623 110.737 92.9727 113.283 94.3327 115.084C90.9951 116.686 87.6575 118.288 84.3198 119.887C83.8174 120.128 83.2862 120.375 82.7294 120.343C81.539 120.272 80.8254 119.024 80.3294 117.935C79.3534 115.794 78.3518 113.476 78.787 111.161C78.9886 110.088 79.491 109.09 79.6894 108.014C80.643 102.849 74.4733 97.9236 76.3645 93.0242C77.2093 90.8378 79.4142 89.544 80.9086 87.7428C83.5134 84.5996 83.8846 79.9828 86.6879 77.0162C91.9807 71.4138 102.362 76.0017 101.565 83.781C100.915 90.1251 89.1327 94.5428 92.0639 101.423V101.426Z",
    fill: "#292949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.995 209.825C167.995 209.825 142.737 118.48 116.608 107.279L116.596 107.262V107.272C116.557 107.256 116.519 107.237 116.48 107.221C116.48 107.221 111.565 107.699 111.626 107.847L108.41 136.594L97.5938 114.3L98.1794 167.981L103.616 219.135L117.767 208.752L141.143 208.694L167.998 209.821L167.995 209.825Z",
    fill: "#D67086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.683 116.063C101.098 116.082 99.9298 111.956 100.515 111.369C101.101 110.781 103.731 111.077 106.071 110.489C108.41 109.902 109.872 108.142 110.163 110.489C110.455 112.836 111.332 115.77 101.683 116.063Z",
    fill: "#FFFFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.403 106.592L124.88 106.268L161.143 133.23L156.935 144.274L144.308 140.053L122.736 113.591L118.403 106.592Z",
    fill: "#D67086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.201 144.926L164.382 135.831L155.044 106.088L148.897 108.589L147.22 137.78L159.201 144.926Z",
    fill: "#D67086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.88 220.471L90.8184 206.563L100.566 144.435L148.451 126.818L188.627 158.343L178.88 220.471Z",
    fill: "#02139D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.127 159.801C204.692 154.76 198.254 149.716 191.818 144.676C181.409 136.524 171.002 128.369 160.592 120.217C158.077 118.246 155.604 116.201 153.037 114.3C151.411 113.096 149.607 112.875 147.751 113.568C146.563 114.011 145.392 114.493 144.211 114.955C132.835 119.418 121.456 123.881 110.08 128.343C100.851 131.965 91.5484 135.442 82.3771 139.211C82.2235 139.272 82.0699 139.33 81.9195 139.391C79.6059 140.3 78.4027 143.054 79.3083 145.376C80.2171 147.706 82.9499 148.907 85.2731 147.995C92.7612 145.058 100.246 142.12 107.734 139.186C119.61 134.527 131.488 129.868 143.363 125.21C145.283 124.455 147.203 123.704 149.123 122.95C154.957 127.522 160.794 132.09 166.628 136.662C177.117 144.878 187.607 153.094 198.097 161.313C200.497 163.194 202.9 165.076 205.3 166.957C207.259 168.492 210.183 168.264 211.78 166.302C213.332 164.398 213.095 161.342 211.127 159.801Z",
    fill: "#DCF2FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.619 168.584L110.146 165.191L103.631 206.69L125.104 210.083L131.619 168.584Z",
    fill: "#FFFFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.795 172.721L146.115 170.875L144.547 180.868L156.227 182.714L157.795 172.721Z",
    fill: "#55C88F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.084 175.139L161.404 173.293L159.836 183.286L171.516 185.132L173.084 175.139Z",
    fill: "#55C88F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.646 186.396L143.966 184.551L142.397 194.544L154.077 196.39L155.646 186.396Z",
    fill: "#55C88F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.939 188.814L159.259 186.969L157.69 196.962L169.37 198.808L170.939 188.814Z",
    fill: "#55C88F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9697 172.672L92.0323 167.121L131.54 190.411L128.372 196.886L85.9874 184.885L78.9697 172.672Z",
    fill: "#D67086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.73 192.064L137.066 188.648L142.404 188.735L141.21 190.97L148.718 192.87L145.201 197.667L128.074 196.81L130.73 192.064Z",
    fill: "#EACDB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.982 106.385L153.271 100.693L147.841 97.832L145.617 99.4405L146.318 106.603L149.527 108.449L153.982 106.385Z",
    fill: "#EACDB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_393_5465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 141,
    height: 313,
    fill: "white",
    transform: "translate(76)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingMob);
export default __webpack_public_path__ + "static/media/landing-mob.8e4b983ee564b8dfb846b4719eff0120.svg";
export { ForwardRef as ReactComponent };